var RemarkListComponent = /** @class */ (function () {
    function RemarkListComponent() {
        this.compact = false;
        this.linkify = true;
        this._cls = true;
    }
    Object.defineProperty(RemarkListComponent.prototype, "_clsCompact", {
        get: function () {
            return this.compact;
        },
        enumerable: true,
        configurable: true
    });
    return RemarkListComponent;
}());
export { RemarkListComponent };
